import { createAction, createAsyncAction } from "typesafe-actions";

import type { ContactsCountry } from "app/pages/sales-intelligence/modules/company-analysis/types/contacts";
import type { QuotaOperationState } from "app/pages/sales-intelligence/modules/quota/types";
import type {
    ContactDetails,
    ContactSearchEntry,
    RevealedContactSearchEntry,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type { FetchError } from "app/pages/sales-intelligence/types";

export const fetchTabContacts = createAsyncAction(
    "@@si/right-sidebar/contacts-tab/fetch-contacts-started",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-succeeded",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-failed",
)<boolean, { contacts: (ContactSearchEntry | RevealedContactSearchEntry)[]; totalCount: number }, FetchError>();

export const fetchContactsCountries = createAsyncAction(
    "@@si/right-sidebar/contacts-tab/fetch-contacts-countries-started",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-countries-succeeded",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-countries-failed",
)<void, ContactsCountry[], FetchError>();

export const setSearchTerm = createAction("@@si/right-sidebar/contacts-tab/set-search-term")<string | null>();

export const setPage = createAction("@@si/right-sidebar/contacts-tab/set-page")<number | null>();

export const setCurrentCountriesIds = createAction("@@si/right-sidebar/contacts-tab/set-current-countries-ids")<
    readonly number[] | null
>();

export const setContactTabDetails = createAction(
    "@@si/right-sidebar/contacts-tab/set-contact-details",
)<ContactDetails | null>();

export const setCurrentProfile = createAction(
    "@@si/right-sidebar/contacts-tab/set-current-profile",
)<ProfileDto | null>();

export const setEditedProfile = createAction("@@si/right-sidebar/contacts-tab/set-edited-profile")<ProfileDto | null>();

export const changeRemainingQuota = createAction(
    "@@si/right-sidebar/contacts-tab/change-remaining-quota",
)<QuotaOperationState>();

export const fetchContactsQuota = createAsyncAction(
    "@@si/right-sidebar/contacts-tab/fetch-contacts-quota-started",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-quota-succeeded",
    "@@si/right-sidebar/contacts-tab/fetch-contacts-quota-failed",
)<void, QuotaOperationState, FetchError>();
